var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ep__app_container", attrs: { id: "app" } },
    [
      _c("router-view"),
      _c("ErrorDialog", {
        attrs: {
          isOpen: !!_vm.globalError,
          title: _vm.globalError ? _vm.globalError.title : null,
          description: _vm.globalError ? _vm.globalError.message : null
        },
        on: { "update:isOpen": _vm.handleErrorUpdateIsOpen }
      }),
      _c("DialogConfirmNavigation", {
        attrs: { isOpen: _vm.isOpenModalNavigation, closeOnClickOutside: false }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }